import { render, staticRenderFns } from "./DragDropFiles.vue?vue&type=template&id=6c65f51e&scoped=true&"
import script from "./DragDropFiles.vue?vue&type=script&lang=ts&"
export * from "./DragDropFiles.vue?vue&type=script&lang=ts&"
import style0 from "./DragDropFiles.vue?vue&type=style&index=0&id=6c65f51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c65f51e",
  null
  
)

export default component.exports